import tableMixin from "../../../components/table/table-mixin.js"
import url from "../../../utils/url"

const FilterModel = () => ({
  start_date_from: '',
  start_date_to: '',
  end_date_from: '',
  end_date_to: ''
})

export default {
  mixins: [tableMixin],
  data () {
    return {
      filterModel: new FilterModel()
    }
  },
  computed: {
    prevRoute () {
      return url.getRoute(this.$route, true)
    },
    exportItemsToFormat () {
      return 'csv'
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    return tableMixin.asyncData({store, route, fromRoute, methods})
  }
}
